module.exports = __webpack_public_path__ + "img/arrow-up.e9e02783.svg";